import { gql } from '@apollo/client';

export const VALIDATE_CUSTOMER = gql`
  query Query(
    $accountNumber: String
    $dob: Date
    $firstName: String
    $lastName: String
  ) {
    validateCustomerWebsite(
      accountNumber: $accountNumber
      dob: $dob
      firstName: $firstName
      lastName: $lastName
    ) {
      primaryContactCustomerNumber
      account {
        accountId
        fuel
        accountType
      }
    }
  }
`;

export const REGISTER_DIRECT_DEBIT = gql`
  mutation RegisterDirectDebitWebsite(
    $registerDirectDebitInput: RegisterDirectDebitInput
  ) {
    registerDirectDebitWebsite(
      registerDirectDebitInput: $registerDirectDebitInput
    ) {
      successfullySubmitted
      error {
        message
        code
      }
      timestamp
    }
  }
`;
export const REGISTER_DIRECT_DEBIT_STRIPE = gql`
  mutation SetupDirectDebitWeb($input: SetupDirectDebitMAInput!) {
    directDebit {
      setupDirectDebitWeb(input: $input) {
        successfullySubmitted
        message
        timestamp
        clientSecret
      }
    }
  }
`;

export const CONFIRM_CARD_WEBSITE = gql`
  mutation ConfirmCardWebsite($input: ConfirmCardInput!) {
    confirmCardWebsite(input: $input) {
      isSuccess
      clientSecret
      intentStatus
      error {
        code
        message
      }
    }
  }
`;
